<template>
  <div v-if="wine">
    <div class="wine">
      <div class="wine__content">
        <div class="wine-header">
          <div class="">
            <span class="wine__cat" :class="wine.fields.Categoria | lowerCase">{{ wine.fields.Categoria }}</span>
            <h1 class="wine__name">{{ wine.fields.Nome }}</h1>
            <div class="wine__price">{{ wine.fields.Prezzo | currency }}</div>
          </div>
        </div>

        <div class="wine-infos">
          <div class="wine-infos__first">
            <div class="">
              <div class="wine-info wine__year" v-if="wine.fields.Anno">
                <div class="key">Anno</div>
                <div class="value">{{ wine.fields.Anno }}</div>
              </div>
              <div class="wine-info wine__alcool" v-if="wine.fields.gradoAlcolico">
                <div class="key">Alcool</div>
                <div class="value">{{ Number((wine.fields.gradoAlcolico * 100).toFixed(1)) }} %</div>
              </div>
              <div class="wine-info wine__winery" v-if="wine.fields.Cantina">
                <div class="key">Cantina</div>
                <div class="value">{{ wine.fields.Cantina }}</div>
              </div>
              <div class="wine__desc">
                <div class="wine-info wine__grapes" v-if="wine.fields.Uve">
                  <div class="key">Uve</div>
                  <div class="value">{{ wine.fields.Uve }}</div>
                </div>
                <div class="wine-info wine__prod" v-if="wine.fields.Produzione">
                  <div class="key">Metodo di produzione</div>
                  <div class="value" v-if="wine.fields.Produzione === 'Biodinamico'"><i class="las la-moon"></i> {{ wine.fields.Produzione }}</div>
                  <div class="value" v-else-if="wine.fields.Produzione === 'Biologico'"><i class="las la-leaf"></i> {{ wine.fields.Produzione }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="position: absolute; color: #999; bottom: 0; right: 0; left: 0; margin: auto; text-align: center">{{ wine.fields.Posizione }}</div>
      </div>

      <div class="wine__img-container">
        <div class="wine__img" v-if="wine.fields.Foto">
          <!-- <img :src="wine.fields.Foto[0].url" /> -->
          <v-img :aspect-ratio="2 / 8" cover :src="wine.fields.Foto[0].thumbnails.large.url"> </v-img>
        </div>
        <div class="wine__img" v-else>
          <v-img contain :src="require('../../images/wine-placeholder--large.svg')"></v-img>
        </div>
      </div>

      <!-- <section class="wine-infos"></section> -->
    </div>

    <!-- <section class="wine-relateds" v-if="relateds.length">
      <v-divider></v-divider>
      <v-container>
        <v-row class="mt-3">
          <v-col>
            <h2 class="text-left">Potrebbero interessarti</h2>
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col>
            <template>
              <div class="wine-list">
                <v-list subheader flat>
                  <v-list-item class="wine-item" v-for="wine in relateds" :key="wine.fields.id" :to="{ name: 'vino', params: { id: wine.id } }" :ripple="false">
                    <span
                      v-if="
                        wine.fields.Categoria === 'Rossi' ||
                        wine.fields.Categoria === 'Bianchi' ||
                        wine.fields.Categoria === 'Dolci' ||
                        wine.fields.Categoria === 'Bollicine' ||
                        wine.fields.Categoria === 'Rosati'
                      "
                      class="wine-item__cat"
                      :class="wine.fields.Categoria | lowerCase"
                      >{{ wine.fields.Categoria }}</span
                    >
                    <div class="wine-item__img">
                      <img :class="wine.fields.Categoria | lowerCase" width="40" height="140" v-if="wine.fields.Foto" :src="wine.fields.Foto[0].thumbnails.large.url" />
                      <img :class="wine.fields.Categoria | lowerCase" contain height="140" v-else src="../../images/wine-placeholder.svg" />
                    </div>

                    <div class="wine-item__content">
                      <div class="wine-item__text">
                        <span class="wine-item__winery" v-if="wine.fields.Cantina">{{ wine.fields.Cantina }} | </span>
                        <span v-if="wine.fields.Anno" class="wine-item__year">{{ wine.fields.Anno }}</span>
                        <h4 class="wine-item__title">{{ wine.fields.Nome }}</h4>
                        <div class="wine-item__grapes">{{ wine.fields.Uve }}</div>
                      </div>

                      <div class="wine-item__footer">
                        <div class="wine-item__infos">
                          <div v-if="wine.fields.gradoAlcolico" class="item__alcohol">{{ Number((wine.fields.gradoAlcolico * 100).toFixed(1)) }} %</div>
                          <div class="wine-item__icon"></div>
                        </div>

                        <div class="wine-item__price" v-if="wine.fields.Prezzo">
                          {{ wine.fields.Prezzo | currency }}
                          <div class="wine-item__size" v-if="wine.fields.Formato">{{ wine.fields.Formato }}</div>
                        </div>
                      </div>
                    </div>
                  </v-list-item>
                </v-list>
              </div>
            </template>
          </v-col>
        </v-row>
      </v-container>
    </section> -->
  </div>
</template>

<script>
export default {
  name: 'Wine',
  props: ['wine'],
  filters: {
    lowerCase: function (value) {
      if (!value) return '';
      value = value.toString();
      return value.toLowerCase();
    }
  },
  watch: {
    '$route.params.id': function () {
      this.createRelateds();
    }
  },
  created: function () {
    this.createRelateds();
  },
  methods: {
    createRelateds() {
      const returnQuantity = 3;
      const pricePercentage = 1.3;
      this.relateds = this.$store.state.data.filter((obj) => {
        return (
          Number(obj.fields.Prezzo) >= Number(this.wine.fields.Prezzo) &&
          Number(obj.fields.Prezzo) < Number(this.wine.fields.Prezzo) * pricePercentage &&
          obj.fields.Categoria === this.wine.fields.Categoria &&
          obj.id !== this.wine.id
        );
      });
      this.relateds = this.relateds.slice(0, returnQuantity);
    }
  }
};
</script>

<style>
.wine {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  justify-content: space-between;
  align-items: flex-start;

  padding: 16px;
  grid-gap: 0px;

  background: #fff;
  border-radius: 16px;
}

@media (min-width: 768px) {
  .wine {
    grid-template-columns: 3fr 1fr;

    padding: 32px;
    grid-gap: 16px;
  }
}

.wine-item__text {
  width: 80%;
}
.wine-item__cat {
  transform: rotate(90deg);
  position: absolute;
  left: calc(100% - 0.5rem);
  top: 1rem;
  transform-origin: left top;
  font-size: 0.875rem;
  text-transform: uppercase;
}

.wine-item__cat.rossi {
  color: #b11226;
}

.wine-item__cat.bianchi {
  color: #c8ad76;
}

.wine-item__cat.bollicine {
  color: #cfcaaf;
}
.wine-item__cat.rosati {
  color: #c96c71;
}
.wine-item__cat.dolci {
  color: #bc552a;
}
</style>
